<template>
  <!-- <Transition name="bounce" mode="out-in" v-show="speechMode"> -->
    <router-view></router-view>
  <!-- </Transition> -->
</template>

<script>

export default {
  name: "App",
}
</script>


